import React, {useRef} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {
  ExternalCustomFieldConfigSearchRequest
} from '../../loan-applications/loan-application/steps/customer-data/hooks/use-custom-field-config-query.hook';
import {CloseSidePanel} from '../side-panel/SidePanel';
import SidePanelWithIconButton from '../side-panel/SidePanelWithIconButton';
import LinkIcon from '@material-ui/icons/Link';
import ExternalCustomFieldSelection from './ExternalCustomFieldSelection';

interface Props {
  externalCustomFieldConfigId?: number;
  handleSave: (customFieldId?: number) => void;
  externalCustomFieldSearchRequest: ExternalCustomFieldConfigSearchRequest;
}

export default function ExternalCustomFieldSidePanel({
                                                       handleSave,
                                                       externalCustomFieldConfigId,
                                                       externalCustomFieldSearchRequest
                                                     }: Props): React.ReactElement {

  const {t} = useTranslation();
  const tooltip = t('COMMON.TOOLTIPS.MAP_TO_CBS');
  const header = <Trans>COMMON.SELECT_CBS_CUSTOM_FIELDS</Trans>;
  const panelRef = useRef<CloseSidePanel>(null);
  const handleFieldSave = (externalCustomFieldConfigId?: number): void => {
    handleSave(externalCustomFieldConfigId);
    panelRef.current?.close();
  };

  return (
    <SidePanelWithIconButton ref={panelRef}
                             header={header}
                             icon={<LinkIcon />}
                             tooltip={tooltip}
                             grayout={!!externalCustomFieldConfigId}
                             disabled={!externalCustomFieldSearchRequest.fieldType}>

      <ExternalCustomFieldSelection
        handleSave={handleFieldSave}
        externalCustomFieldConfigId={externalCustomFieldConfigId}
        externalCustomFieldConfigSearchRequest={externalCustomFieldSearchRequest}
      />
    </SidePanelWithIconButton>
  );
}
